import { render, staticRenderFns } from "./ExhibitionSettings.vue?vue&type=template&id=65bd4736&"
import script from "./ExhibitionSettings.vue?vue&type=script&lang=ts&"
export * from "./ExhibitionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ExhibitionSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VProgressCircular,VTextField})
